'use client';
import { useMemo } from 'react';
import { useTheme } from 'next-themes';

// src/hooks/use-theme-control.ts
var themes = ["light", "dark"];
var useThemeControl = () => {
  const { resolvedTheme, forcedTheme, setTheme } = useTheme();
  const theme = useMemo(() => {
    if (!resolvedTheme) {
      return "light";
    }
    if (themes.includes(forcedTheme)) {
      return forcedTheme;
    }
    return themes.includes(resolvedTheme) ? resolvedTheme : "light";
  }, [resolvedTheme, forcedTheme]);
  return {
    theme,
    setTheme
  };
};
var use_theme_control_default = useThemeControl;

export { use_theme_control_default as default };
